































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AssessmentReview extends Vue {

  @Prop() private goal!: any;
  @Prop() private audience!: any;
  @Prop() private presentation!: any;
  @Prop() private practice!: any;

  private gridItemsList: any[] = []
  private listItemsList: any[] = []

  private created() {
    this.gridItemsList.push(this.goal);
    this.gridItemsList.push(this.audience);
    this.listItemsList.push(this.presentation);
    this.listItemsList.push(this.practice);
  }

  private gotoNext() {
    this.$emit("gotoNext");
  }

  private gotoEdit() {
    this.$emit("gotoEdit");
  }
}
